import { FETCH_PHARMACYORDERS_REQUEST,FETCH_PHARMACYORDERS_SUCCESS,FETCH_PHARMACYORDERS_FAILURE,FETCH_LABORDERS_REQUEST,FETCH_LABORDERS_SUCCESS,FETCH_LABORDERS_FAILURE, FETCH_INCLINICORDERS_REQUEST, FETCH_INCLINICORDERS_SUCCESS, FETCH_INCLINICORDERS_FAILURE, FETCH_ORDER_REPORTS_REQUEST, FETCH_ORDER_REPORTS_SUCCESS, FETCH_ORDER_REPORTS_FAILURE, FETCH_ORDER_REPORTS_COUNT_REQUEST, FETCH_ORDER_REPORTS_COUNT_SUCCESS, FETCH_ORDER_REPORTS_COUNT_FAILURE, FETCH_OPORDERS_REQUEST, FETCH_OPORDERS_SUCCESS, FETCH_OPORDERS_FAILURE } from "../actions/orderActions";

const initialState = {
    pharmacyOrders: [],
    labOrders:[],
    inclinicOrders:[],
    opOrders:[],
    orderReports:[],
    orderReportsCount:0,
    isLoading: false,
    countLoading:false,
    error: null
};

export const ordersReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PHARMACYORDERS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_PHARMACYORDERS_SUCCESS:
            return { ...state, pharmacyOrders: action.payload, isLoading: false };

        case FETCH_PHARMACYORDERS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_LABORDERS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_LABORDERS_SUCCESS:
            return { ...state, labOrders: action.payload, isLoading: false };

        case FETCH_LABORDERS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_INCLINICORDERS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_INCLINICORDERS_SUCCESS:
            return { ...state, inclinicOrders: action.payload, isLoading: false };

        case FETCH_INCLINICORDERS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_OPORDERS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_OPORDERS_SUCCESS:
            return { ...state, opOrders: action.payload, isLoading: false };

        case FETCH_OPORDERS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_ORDER_REPORTS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_ORDER_REPORTS_SUCCESS:
            return { ...state, orderReports: action.payload, isLoading: false };

        case FETCH_ORDER_REPORTS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_ORDER_REPORTS_COUNT_REQUEST:
            return { ...state, countLoading: true };

        case FETCH_ORDER_REPORTS_COUNT_SUCCESS:
            return { ...state, orderReportsCount: action.payload, countLoading: false };

        case FETCH_ORDER_REPORTS_COUNT_FAILURE:
            return { ...state, error: action.payload, countLoading: false };

        default:
            return state;
    }
};